import { z } from 'zod';

const optionIds = z.array(z.uuidv7());
const optionTexts = z.array(z.string().trim().min(1));

export const submittedAnswerSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('text-input'), value: z.string() }).strict(),
  z
    .object({
      order: z.array(z.int().nonnegative()).min(2).max(9),
      type: z.literal('order-words'),
    })
    .strict(),
  z
    .object({
      presentedOptionIds: optionIds,
      selectedOptionId: z.uuidv7(),
      type: z.literal('choice'),
    })
    .strict(),
  z
    .object({
      presentedOptionIds: optionIds,
      selectedOptionIds: optionIds,
      type: z.literal('multi-choice'),
    })
    .strict(),
]);

export const storedAnswerSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('text-input'), value: z.string() }).strict(),
  z
    .object({
      order: z.array(z.int().nonnegative()).min(2).max(9),
      type: z.literal('order-words'),
    })
    .strict(),
  z
    .object({
      presentedOptions: optionTexts,
      selectedOption: z.string().trim().min(1),
      type: z.literal('choice'),
    })
    .strict(),
  z
    .object({
      presentedOptions: optionTexts,
      selectedOptions: optionTexts,
      type: z.literal('multi-choice'),
    })
    .strict(),
]);

export const reviewEventSchema = z
  .object({
    answer: storedAnswerSchema,
    cardId: z.uuidv7(),
    id: z.uuidv7(),
    occurredAt: z.int().nonnegative(),
    result: z.enum(['correct', 'incorrect']),
  })
  .strict();

export const appendReviewEventSchema = reviewEventSchema
  .omit({ id: true })
  .extend({ id: z.uuidv7().optional() });

export type SubmittedAnswer = z.infer<typeof submittedAnswerSchema>;
export type StoredAnswer = z.infer<typeof storedAnswerSchema>;
export type ReviewEvent = z.infer<typeof reviewEventSchema>;
export type AppendReviewEvent = z.input<typeof appendReviewEventSchema>;

export type CardProgress = {
  attempts: number;
  firstSeenAt: number | null;
  lastCorrectAt: number | null;
  lastSeenAt: number | null;
};
